export const JpFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      style={{ borderRadius: '10px', backgroundColor: '#fff' }}
    >
      {/* Taeguk symbol */}
      <circle
        cx="10"
        cy="10"
        r="5"
        fill="#CD2E3A"
      />
      <path
        d="M10 5a5 5 0 1 0 0 10a2.5 2.5 0 1 1 0-10z"
        fill="#003478"
      />
    </svg>
  );
};
